
import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";

export default BaseCmsBlock.extend({
  name: "TypesImageFeaturesBlock",

  data: function () {
    return {
      isMore: false
    }
  },

  computed: {
    titleH2: function () {
      return this?.values.title || this.externalData?.TypesImageFeaturesBlock?.title || ""
    },

    localValues: function () {
      return this.externalData?.TypesImageFeaturesBlock || this.values || {}
    },
    products: function () {
      const products = this.externalData?.TypesImageFeaturesBlock?.products || this.extras?.products || [];
      if (!this.isMore) {
        return [...(products || [])].splice(0, 9)
      }

      return products || []
    },

    isEmpty: function () {
      return this.products.length <= 0
    },
    isVisibleMore: function () {
      const products = this.externalData?.TypesImageFeaturesBlock?.products || this.extras?.products || [];
      return Boolean(!this.isMore && products.length > 8)
    }
  },

  components: {
    Card: () => import("./components/TypesImageFeaturesBlock/Card")
  }
});
